import type { StandardEquipmentView } from "@slfinrtl/ui-bff-routes"
import { getStandardEquipmentRoute } from "@slfinrtl/ui-bff-routes"
import { useEffect, useState } from "react"
import { defineMessages, useIntl } from "react-intl"
import { Stage } from "src/components"
import { ErrorNotificationInline } from "src/context/errorHandler/ErrorNotificationInline"
import { withErrorHandler } from "src/context/errorHandler/withErrorHandler"
import { useBff } from "src/hooks"
import { StandardEquipment } from "./components/StandardEquipment"
import { StandardEquipmentSkeleton } from "./components/StandardEquipmentSkeleton"

const messages = defineMessages({
	standardEquipmentTitle: {
		defaultMessage: "Standard Equipment",
		id: "standardEquipment.title",
	},
})

interface StandardEquipmentContainerProps {
	inventoryId: string
}

export const StandardEquipmentContainer = withErrorHandler(({ inventoryId }: StandardEquipmentContainerProps) => {
	const { formatMessage } = useIntl()
	const [standardEquipmentView, setStandardEquipmentView] = useState<StandardEquipmentView | null>()
	const [openAccordions, setOpenAccordions] = useState<Record<number, boolean>>({})

	const fetchStandardEquipment = useBff(
		getStandardEquipmentRoute,
		{
			body: undefined,
			pathParams: {},
			queryParams: {
				"inventory-id": inventoryId,
			},
		},
		"inline",
	)

	useEffect(() => {
		fetchStandardEquipment()
			.then(setStandardEquipmentView)
			.catch(() => setStandardEquipmentView(null))
	}, [fetchStandardEquipment])

	return (
		<Stage title={formatMessage(messages.standardEquipmentTitle)}>
			<ErrorNotificationInline dismissButton={false} />
			{standardEquipmentView === undefined ? (
				<StandardEquipmentSkeleton />
			) : standardEquipmentView === null ? null : (
				<StandardEquipment
					view={standardEquipmentView}
					openAccordions={openAccordions}
					setOpenAccordions={setOpenAccordions}
				/>
			)}
		</Stage>
	)
})
